import { useEffect, useRef } from 'react'

import { useAppDispatch } from 'common/hooks/redux'

import { resyncTeam } from 'features/TeamChat/api/teamChat.cache'

export const TEAM_POLL_MS = 30_000
export const FOCUS_RESYNC_MS = 10_000

type Args = { enabled: boolean; isLive: boolean }

const isVisible = () => document.visibilityState === 'visible'

// Polls while there is no live socket and catches up when the tab comes back or the window regains focus.
export const useTeamResync = ({ enabled, isLive }: Args): void => {
  const dispatch = useAppDispatch()
  const lastFocusSync = useRef(0)

  useEffect(() => {
    if (!enabled || isLive) return
    // A hidden tab skips the tick; the visibility resync catches it up.
    const timer = setInterval(() => isVisible() && dispatch(resyncTeam()), TEAM_POLL_MS)
    return () => clearInterval(timer)
  }, [enabled, isLive, dispatch])

  useEffect(() => {
    if (!enabled) return
    const onReturn = () => {
      if (!isVisible()) return
      if (Date.now() - lastFocusSync.current < FOCUS_RESYNC_MS) return
      lastFocusSync.current = Date.now()
      dispatch(resyncTeam())
    }
    document.addEventListener('visibilitychange', onReturn)
    window.addEventListener('focus', onReturn)
    return () => {
      document.removeEventListener('visibilitychange', onReturn)
      window.removeEventListener('focus', onReturn)
    }
  }, [enabled, dispatch])
}
